import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Motion";

const base = "group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition-[background-color,color,box-shadow,transform] duration-300 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#2878E5]/30";
const variants = {
  primary: "bg-[#2878E5] text-white shadow-[0_8px_24px_rgba(40,120,229,0.35)] hover:bg-[#1f68cc] hover:shadow-[0_12px_32px_rgba(40,120,229,0.45)]",
  navy: "bg-[#102B50] text-white hover:bg-[#0A1E3A]",
  outline: "border border-slate-300 bg-white text-[#102B50] hover:border-[#102B50]",
  light: "bg-white text-[#102B50] hover:bg-[#E8F1FD]",
  ghostLight: "border border-white/30 text-white hover:bg-white/10",
};

export const Btn = ({ to, href, variant = "primary", arrow = true, children, className = "", ...rest }) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {arrow && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
    </>
  );
  if (href) return <a href={href} className={cls} {...rest}>{inner}</a>;
  if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
  return <button className={cls} {...rest}>{inner}</button>;
};

export const SectionHead = ({ eyebrow, title, text, center = false, light = false, className = "" }) => (
  <Reveal className={`${center ? "mx-auto text-center" : ""} max-w-3xl ${className}`}>
    {eyebrow && <span className={`eyebrow ${light ? "!text-[#8EC0FF] before:!bg-[#8EC0FF]" : ""}`}>{eyebrow}</span>}
    <h2 className={`mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-[44px] lg:leading-[1.1] ${light ? "text-white" : "text-[#102B50]"}`}>
      {title}
    </h2>
    {text && <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-slate-300" : "text-[#4A5D78]"}`}>{text}</p>}
  </Reveal>
);

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10 ${className}`}>{children}</div>
);

export const IconBadge = ({ icon: Icon, dark = false }) => (
  <span className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${dark ? "bg-white/10 text-white" : "bg-[#E8F1FD] text-[#2878E5]"} transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105`}>
    <Icon className="h-5 w-5" strokeWidth={1.8} />
  </span>
);

export const CheckList = ({ items, light = false }) => (
  <ul className="space-y-3">
    {items.map((t) => (
      <li key={t} className={`flex items-start gap-3 text-[15px] ${light ? "text-slate-200" : "text-[#2D3F58]"}`}>
        <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#2878E5]" />
        {t}
      </li>
    ))}
  </ul>
);
